// @ts-nocheck -- staged migration: add explicit types before removing this directive.
export const VISIT_COUNTER_URL = "https://d29a52ery9.execute-api.us-east-1.amazonaws.com/prod/visits";

export function trackPageVisit(path) {
    try {
        const payload = {
            path,
            screenWidth: window.screen?.width,
            screenHeight: window.screen?.height,
            viewportWidth: window.innerWidth,
            viewportHeight: window.innerHeight,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
        fetch(VISIT_COUNTER_URL, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
            keepalive: true,
        }).catch(() => {});
    } catch {
        // Visit tracking is best-effort and should never break the page.
    }
}

export function fetchVisitCount() {
    return fetch(VISIT_COUNTER_URL)
        .then((response) => response.json())
        .then((data) => (typeof data.visits === "number" ? data.visits : null));
}

export function fetchVisitStats() {
    return fetch(`${VISIT_COUNTER_URL}?stats=true`).then((response) => response.json());
}

export async function fetchAdminStats(accessToken) {
    const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL;
    if (!ADMIN_API_URL) throw new Error("The admin API is not configured.");

    const response = await fetch(`${ADMIN_API_URL.replace(/\/$/, "")}/stats`, {
        headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) throw new Error(`Admin stats request failed (${response.status}).`);
    return response.json();
}
